import { AssetsService } from '@coosmo/shared-utils'

const zoomInImage = AssetsService.getSvgIcon('zoom-in-grey.svg')
const zoomOutImage = AssetsService.getSvgIcon('zoom-out-grey.svg')

function setupZoom(viewer) {
  viewer.addHandler('zoom', () => {
    let bestAvailableViewPort = viewer.viewport
    if (viewer.world.getItemAt) {
      bestAvailableViewPort = viewer.world.getItemAt(0) || bestAvailableViewPort
    }
    let currentZoom = bestAvailableViewPort.viewportToImageZoom(viewer.viewport.getZoom())

    currentZoom = Math.round((currentZoom / viewer.maxZoomPixelRatio) * 100)
    currentZoom = Math.max(1, currentZoom)

    let currentZoomString = `${currentZoom}%`
    const zoomValueElement = document.getElementById(`zoom-value`)
    if (zoomValueElement) {
      zoomValueElement.innerHTML = currentZoomString
    }
  })
}

export default {
  createDom: function (isOnPremises) {
    const navigatorAndButtonsContainerOnPremises = isOnPremises ? 'navigatorAndButtonsContainerOnPremises' : ''

    const navigatorContainerOnPremises = isOnPremises ? 'navigatorContainerOnPremises' : ''

    return `
<div id="navigatorWithButtons" class="navigatorAndButtonsContainer ${navigatorAndButtonsContainerOnPremises}">
  <div id="navigatorContainer" class="navigatorContainer ${navigatorContainerOnPremises}">
    <div id="navigator" class="navigator"></div>
  </div>
  <div id="navigatorButtonsContainer">
    <div class="zoomButton zoomInButton" id="zoom-in"><img src="${zoomInImage}"/></div>
    <div class="zoomValue" id="zoom-value">2x</div>
    <div class="zoomButton zoomOutButton" id="zoom-out"><img src="${zoomOutImage}"/></div>
  </div>
</div>
`
      .replace(/\n/g, '')
      .replace(/>\s+/g, '>')
  },

  setup: function (viewer) {
    const navigator = document.getElementById(`navigatorWithButtons`)
    navigator.addEventListener('mouseenter', () => {
      let visibleOpacity = this.getMaxOpacity()
      document.getElementById(`zoom-in`).style['opacity'] = visibleOpacity
      document.getElementById(`zoom-out`).style['opacity'] = visibleOpacity
    })

    navigator.addEventListener('mouseleave', () => {
      document.getElementById(`zoom-in`).style['opacity'] = '0'
      document.getElementById(`zoom-out`).style['opacity'] = '0'
    })

    let timeout = undefined

    viewer.addHandler('animation', () => {
      navigator.style['opacity'] = this.getMaxOpacity()
      clearTimeout(timeout)
      timeout = setTimeout(() => (navigator.style['opacity'] = '0'), 1500)
    })

    document.addEventListener('mousemove', () => {
      navigator.style['opacity'] = this.getMaxOpacity()
      clearTimeout(timeout)
      timeout = setTimeout(() => (navigator.style['opacity'] = '0'), 1500)
    })
    setupZoom(viewer)
  },
  getMaxOpacity: function () {
    const navigator = document.getElementById(`navigatorWithButtons`)
    let opacity = '0.8'
    if (navigator) {
      let doNotShow = navigator.getAttribute('doNotShow')
      if (doNotShow === 'true') {
        opacity = 0
      }
    }
    return opacity
  },
  hide: function () {
    const navigator = document.getElementById(`navigatorWithButtons`)
    navigator.style.opacity = '0'
    navigator.setAttribute('doNotShow', 'true')
  },
  show: function () {
    const navigator = document.getElementById(`navigatorWithButtons`)
    navigator.setAttribute('doNotShow', 'false')
  }
}
